/**
 * Storage Keys
 * Keys for localStorage and sessionStorage usage.
 */

export const STORAGE_KEYS = {
    // Auth State
    AUTH_STATE: "auth_state",
    SIGNUP_PROGRESS: "signup_progress",

    // Temporary Tokens (Session Storage)
    // SECURITY: These must have short TTL and strict XSS protection on the page
    PRE_SIGNUP_TOKEN: "auth_pre_signup_token",
    PRE_MFA_TOKEN: "auth_pre_mfa_token",
    RECOVERY_REQUEST_ID: "recovery_request_id", // Added
    PASSWORD_RESET_EMAIL: "password_reset_email", // Added

    // Preferences (Local Storage)
    THEME_PREFERENCE: "theme_preference",
    LANGUAGE_PREFERENCE: "language_preference",

    // Cookies
    AUTHENTIK_SESSION: "authentik_session",
    AUTHENTIK_CSRF: "authentik_csrf",
    USER_EMAIL: "user_email",
} as const;
